import * as z from 'zod';

// The one home for these paths. The server mounts the config endpoint and the SPA fetches it, and
// the router and welcome emails link to the routes the SPA registers.
export const PORTAL_LOGIN_CONFIG_PATH = '/api/portal/login-config';
export const PORTAL_LOGIN_PATH = '/login';
export const PORTAL_LOGIN_EMAIL_QUERY_PARAM = 'email';
export const PORTAL_SET_PASSWORD_PATH = '/set-password';

export const PortalLoginSupportContact = z.object({
  email: z.string(),
  phone: z.string(),
  hours: z
    .object({
      line1: z.string().optional(),
      line2: z.string().optional(),
      line3: z.string().optional(),
    })
    .optional(),
});
export type PortalLoginSupportContact = z.infer<typeof PortalLoginSupportContact>;

export const PortalLoginBranding = z.object({
  name: z.string(),
  logoUrl: z.string(),
  primaryColor: z.string().optional(),
});
export type PortalLoginBranding = z.infer<typeof PortalLoginBranding>;

export const PortalLoginConfig = z.discriminatedUnion('willowAuthEnabled', [
  z.object({ willowAuthEnabled: z.literal(false) }),
  z.object({
    willowAuthEnabled: z.literal(true),
    portal: PortalLoginBranding,
    support: PortalLoginSupportContact.optional(),
  }),
]);
export type PortalLoginConfig = z.infer<typeof PortalLoginConfig>;

export type PortalLoginConfigEnabled = Extract<PortalLoginConfig, { willowAuthEnabled: true }>;
